import e from "@dialpad/dialtone-tokens/layered/themes/tokens-mulberry-colors.css?inline";
//#region themes/mulberry.js
var t = {
	brand: {
		css: e,
		name: "mulberry"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
